import httpClient from "../httpClient";
import { API_COMMENT_CREATE } from "../config";

const createComment = {
    create: (data) => httpClient.post(API_COMMENT_CREATE, data),
};

export default createComment;
